






















































































































































import { Component, Mixins } from "vue-property-decorator";
import FooterButton from "@/components/FooterButton.vue";
import { AppData } from "@/models/app-data";
import { required } from "vuelidate/lib/validators";
import CommonMixin from "@/mixins/common-mixins";
import { ContentService } from "@/service/content.service";
import { FinalDetails2Content } from "@/models/content/final-details-2";
import { CommonFormService } from "../../service/common-form.service";
import { CommonFormBuilder } from "@/utils/common-form-builder";
import VueRecaptcha from "vue-recaptcha";

@Component({
  components: {
    FooterButton,
    VueRecaptcha,
  },
  validations: {
    ready4kRadio: {
      required,
    },
    followupRadio: {
      required,
    },
    termsCheck: {
      checked: (value) => value === true,
    },
  },
})
export default class FinalDetails2 extends Mixins(CommonMixin) {
  commonFormService = new CommonFormService();
  commonFormBuilder = new CommonFormBuilder();
  content = {} as FinalDetails2Content;
  appData = {} as AppData;
  followupRadio = false;
  ready4kRadio = false;
  termsCheck = false;
  PercentDone = 100;
  IsSaving = false;
  textDirection = "ltr";
  language!: string;

  async mounted(): Promise<void> {
    try {
      const contentService = new ContentService(this.$route);
      this.content = await contentService.getFinalDetails2Content();
      this.textDirection = contentService.TextDirection();
      this.language = contentService.Language();

      this.appData = this.getAppData();
      if (this.appData != null) {
        this.ready4kRadio = this.appData.signupReady4k ?? true;
        this.followupRadio = this.appData.followUp211 ?? true;
        this.putWorkflowStep( this.appData.workflowId, "FinalDetails2") 
      }
    } catch (error) {
      this.showError(error);
    }
  }

  disableNext(): boolean {
    return this.$v.$invalid || this.IsSaving === true;
  }

  get TheCapcha(): any {
    return this.$refs.captcharef;
  }

  public async handleNextPageEvent(): Promise<void> {
    this.IsSaving = true;
    this.TheCapcha.execute();
  }

  public async save(captchaToken: string): Promise<void> {
    this.appData.signupReady4k = this.ready4kRadio;
    this.appData.followUp211 = this.followupRadio;
    this.appData.language = this.language;
    this.saveAppData(this.appData);
    const commonForm = await this.commonFormBuilder.BuildCommonForm(
      this.appData,
      captchaToken
    );
    await this.updateCommonForm(commonForm);
    this.IsSaving = false;
  }

  async onVerifyCaptcha(captchaToken: string) {
    try {
      this.TheCapcha.reset();
      await this.save(captchaToken);
      this.$router.push({ path: "ThankYou" });
    } catch (err) {
      this.showError("Could not save data");
    }
  }

  onExpiredCaptcha(): void {
    this.TheCapcha.reset();
  }

  onErrorCaptcha(): void {
    if (this.IsSaving === true) {
      this.IsSaving = false;
      this.showError("Captcha Error");
    }
  }
}
